/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import { PicklistFragmentDoc } from '../fragment/Picklist.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllPicklistsQueryVariables = Types.Exact<{
	countryId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetAllPicklistsQuery = {
	__typename?: 'Query';
	countries: Array<{
		__typename?: 'Country';
		id: string;
		name: string;
		states: Array<{ __typename?: 'State'; id: string; name: string }>;
	}>;
	CBSA:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	HCO_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	HCP_GENDER:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	HCP_STATUS:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	HCP_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	LANGUAGE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	LOCAL_SPECIALTY:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	MEDICAL_DEGREE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	RELATION_STATUS:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	RELATION_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	SPECIALTY:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	SPECIALTY_GROUP:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	STATUS:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	LICENSE_STATUS:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	COUNTRY:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	STATE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	HCO_BUSINESS_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	LOCAL_HCP_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	HCP_STATUS_REASON:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	SPECIALTY_LOCAL:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	LOCAL_HCO_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	HCO_HIERARCHY_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	COUNT_RANGE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	OBJECT_ENTITY_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	RELATIONSHIP_TYPE:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	HCO_OWNERSHIP:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
	ACADEMIC_STATUS:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'ReferenceResult';
				results: Array<{
					__typename?: 'Reference';
					name: string;
					localizedName?: string | null;
					id: string;
				}>;
		  };
};

export const GetAllPicklistsDocument = gql`
	query GetAllPicklists($countryId: String) {
		countries {
			id
			name
			states {
				id
				name
			}
		}
		CBSA: reference(payload: { referenceType: CBSA, countryId: $countryId }) {
			...Picklist
		}
		HCO_TYPE: reference(
			payload: { referenceType: HCO_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		HCP_GENDER: reference(
			payload: { referenceType: HCP_GENDER, countryId: $countryId }
		) {
			...Picklist
		}
		HCP_STATUS: reference(
			payload: { referenceType: HCP_STATUS, countryId: $countryId }
		) {
			...Picklist
		}
		HCP_TYPE: reference(
			payload: { referenceType: HCP_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		LANGUAGE: reference(
			payload: { referenceType: LANGUAGE, countryId: $countryId }
		) {
			...Picklist
		}
		LOCAL_SPECIALTY: reference(
			payload: { referenceType: LOCAL_SPECIALTY, countryId: $countryId }
		) {
			...Picklist
		}
		MEDICAL_DEGREE: reference(
			payload: { referenceType: MEDICAL_DEGREE, countryId: $countryId }
		) {
			...Picklist
		}
		RELATION_STATUS: reference(
			payload: { referenceType: RELATION_STATUS, countryId: $countryId }
		) {
			...Picklist
		}
		RELATION_TYPE: reference(
			payload: { referenceType: RELATION_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		SPECIALTY: reference(
			payload: { referenceType: SPECIALTY, countryId: $countryId }
		) {
			...Picklist
		}
		SPECIALTY_GROUP: reference(
			payload: { referenceType: SPECIALTY_GROUP, countryId: $countryId }
		) {
			...Picklist
		}
		STATUS: reference(
			payload: { referenceType: STATUS, countryId: $countryId }
		) {
			...Picklist
		}
		LICENSE_STATUS: reference(
			payload: { referenceType: LICENSE_STATUS, countryId: $countryId }
		) {
			...Picklist
		}
		COUNTRY: reference(
			payload: { referenceType: COUNTRY, countryId: $countryId }
		) {
			...Picklist
		}
		STATE: reference(payload: { referenceType: STATE, countryId: $countryId }) {
			...Picklist
		}
		HCO_BUSINESS_TYPE: reference(
			payload: { referenceType: HCO_BUSINESS_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		LOCAL_HCP_TYPE: reference(
			payload: { referenceType: LOCAL_HCP_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		HCP_STATUS_REASON: reference(
			payload: { referenceType: HCP_STATUS_REASON, countryId: $countryId }
		) {
			...Picklist
		}
		SPECIALTY_LOCAL: reference(
			payload: { referenceType: SPECIALTY_LOCAL, countryId: $countryId }
		) {
			...Picklist
		}
		LOCAL_HCO_TYPE: reference(
			payload: { referenceType: LOCAL_HCO_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		HCO_HIERARCHY_TYPE: reference(
			payload: { referenceType: HCO_HIERARCHY_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		COUNT_RANGE: reference(
			payload: { referenceType: COUNT_RANGE, countryId: $countryId }
		) {
			...Picklist
		}
		OBJECT_ENTITY_TYPE: reference(
			payload: { referenceType: OBJECT_ENTITY_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		RELATIONSHIP_TYPE: reference(
			payload: { referenceType: RELATIONSHIP_TYPE, countryId: $countryId }
		) {
			...Picklist
		}
		HCO_OWNERSHIP: reference(
			payload: { referenceType: HCO_OWNERSHIP, countryId: $countryId }
		) {
			...Picklist
		}
		ACADEMIC_STATUS: reference(
			payload: { referenceType: ACADEMIC_STATUS, countryId: $countryId }
		) {
			...Picklist
		}
	}
	${PicklistFragmentDoc}
`;

/**
 * __useGetAllPicklistsQuery__
 *
 * To run a query within a React component, call `useGetAllPicklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPicklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPicklistsQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetAllPicklistsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllPicklistsQuery,
		GetAllPicklistsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllPicklistsQuery, GetAllPicklistsQueryVariables>(
		GetAllPicklistsDocument,
		options
	);
}
export function useGetAllPicklistsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllPicklistsQuery,
		GetAllPicklistsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllPicklistsQuery,
		GetAllPicklistsQueryVariables
	>(GetAllPicklistsDocument, options);
}
export function useGetAllPicklistsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllPicklistsQuery,
				GetAllPicklistsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllPicklistsQuery,
		GetAllPicklistsQueryVariables
	>(GetAllPicklistsDocument, options);
}
export type GetAllPicklistsQueryHookResult = ReturnType<
	typeof useGetAllPicklistsQuery
>;
export type GetAllPicklistsLazyQueryHookResult = ReturnType<
	typeof useGetAllPicklistsLazyQuery
>;
export type GetAllPicklistsSuspenseQueryHookResult = ReturnType<
	typeof useGetAllPicklistsSuspenseQuery
>;
export type GetAllPicklistsQueryResult = Apollo.QueryResult<
	GetAllPicklistsQuery,
	GetAllPicklistsQueryVariables
>;
